import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-50/60 to-accent-50/40 rounded-lg p-6 md:p-10">
          <div className="flex-shrink-0">
            <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-4xl md:text-5xl text-background-50"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              {appData.badge}
            </span>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">{appData.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 mb-4 leading-relaxed">{appData.description}</p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appData.features.map((f) => (
                <span key={f} className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs md:text-sm border border-background-200 whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}